import angular from 'angular';
import Logger from '../logger';

export const staticDataService = (RouteService, $q) => {
    const deferred = $q.defer();

    RouteService.getStaticData().then((response = {}) => {
        deferred.resolve(response.result);
    })
        .catch(error => Logger.error(error));

    const getStaticData = (field, callback, fieldParent) => deferred.promise.then((data) => {
        const result = data[field];

        if (callback) {
            callback(result, fieldParent);
        }

        return result;
    });

    const getStaticDataDictionary = () => deferred.promise;

    return {
        getStaticData,
        getStaticDataDictionary,
    };
};

angular.module('TALENYA-FE').factory('staticDataService', staticDataService);
